module.exports = __webpack_public_path__ + "static/joshua-tree-9e533ae7a810ba748d90b4446b055e2d.jpg";